import { useContext } from 'react';
import { InformedContext } from '../Context.js';

/* ----------------------- useInformed ----------------------- */
function useInformed() {
  return useContext(InformedContext);
}

export { useInformed };
